import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';

const ActionElement = ({ className, handleOnClick, label, title, action }) => {
  const actionMap = {
    // add: <Add className="flex center jcenter mr8">+</Add>,
    add: (
      <div className="fx center">
        <SVGIcon name="RuleAdd" size="sm" color='#96DD4B'/>
      </div>
    ),
    // remove: <Remove className="flex center jcenter mr8">-</Remove>
    remove: (
      <div className="fx center">
        <SVGIcon name="RuleMinus" size="sm" color='#FA3F3F'/>
      </div>
    )
  };
  return (
    <Button
      className={`${className} flex center`}
      title={title}
      onClick={(e) => handleOnClick(e)}
    >
      {actionMap[action]}
      <Label>{label}</Label>
    </Button>
  );
};

const Label = styled.div`
  color: #1908f7;
  font-weight: bold;
`;

const Button = styled.button`
  background: none !important;
  border: none !important;
  cursor: pointer;
  :focus {
    outline: none;
  }
`;

ActionElement.displayName = 'ActionElement';

ActionElement.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  handleOnClick: PropTypes.func,
  title: PropTypes.string,
  action: PropTypes.string
};

export default ActionElement;
